
import Resumen from "views/Resumen";
import ListaEquipos from "views/ListaEquipos";
import ConsultaEstadoDocs from 'views/ConsultaEstadoDocs';
import ConsultaEstadoFolio from "views/ConsultaEstadoFolio";
import EstadoDocsResumen from "views/EstadoDocsResumen";
import UploadXMLCAF from "views/UploadXMLCAF";
import RangoFolios from "views/RangosFolios";
import CheckDocsBDS3 from "views/CheckDocsBDS3";
import CheckDocumentosCargadosDesdeHasta from "views/CheckDocumentosCargadosDesdeHasta";
import Companies from "views/Companies";
import WebUsers from "views/WebUsers";
import DLQMonitor from "views/DLQMonitor";
import GenerarDocumentoManual from "views/GenerarDocumentoManual";
// import CheckDocsComparacion from "views/CheckDocsComparacion";

const dashboardRoutes = [
  {
    path: "/resumen",
    name: "Resumen",
    icon: "nc-icon nc-chart-pie-35",
    component: Resumen,
    layout: "/admin",
    section: "Dashboard",
  },
  {
    path: "/lista",
    name: "Lista Equipos",
    icon: "nc-icon nc-notes",
    component: ListaEquipos,
    layout: "/admin",
    section: "Monitoreo",
  },
  {
    path: "/dlqmonitor",
    name: "DLQ Monitor",
    icon: "nc-icon nc-notes",
    component: DLQMonitor,
    layout: "/admin",
    section: "Monitoreo",
  },
  {
    path: "/consultaestadodocs",
    name: "Estado Documento",
    icon: "nc-icon nc-zoom-split",
    component: ConsultaEstadoDocs,
    layout: "/admin",
    section: "Documentos",
  },
  {
    path: "/estadodocsresumen",
    name: "Resumen Estado Docs",
    icon: "nc-icon nc-zoom-split",
    component: EstadoDocsResumen,
    layout: "/admin",
    section: "Documentos",
  },
  {
    path: "/checkdocumentoscargados",
    name: "Check Documentos BD S3",
    icon: "nc-icon nc-layers-3",
    component: CheckDocsBDS3,
    layout: "/admin",
    section: "Documentos",
  },
  {
    path: "/checkdocumentoscargadosdesdehasta",
    name: "Check Documentos BD S3 Rango Fecha RR",
    icon: "nc-icon nc-layers-3",
    component: CheckDocumentosCargadosDesdeHasta,
    layout: "/admin",
    section: "Documentos",
  },
  {
    path: "/generardocumentomanual",
    name: "Documento manual",
    icon: "nc-icon nc-ruler-pencil",
    component: GenerarDocumentoManual,
    layout: "/admin",
    section: "Documentos",
  },
  {
    path: "/consultaestadofolio",
    name: "Consulta Folios",
    icon: "nc-icon nc-zoom-split",
    component: ConsultaEstadoFolio,
    layout: "/admin",
    section: "Folios",
  },
  {
    path: "/uploadcaf",
    name: "CAF",
    icon: "nc-icon nc-cloud-upload-94",
    component: UploadXMLCAF,
    layout: "/admin",
    section: "Folios",
  },
  {
    path: "/rangofolios",
    name: "Rango Folios",
    icon: "nc-icon nc-layers-3",
    component: RangoFolios,
    layout: "/admin",
    section: "Folios",
  },
  {
    path: "/companies",
    name: "Empresas",
    icon: "nc-icon nc-paper-2",
    component: Companies,
    layout: "/admin",
    section: "Administración",
  },
  {
    path: "/webusers",
    name: "Usuarios Web",
    icon: "nc-icon nc-single-02",
    component: WebUsers,
    layout: "/admin",
    section: "Administración",
  },
  // {
  //   path: "/checkdocumentoscargadosdesdehasta1",
  //   name: "Check Documentos BD S3 Desde/Hasta",
  //   icon: "nc-icon nc-cloud-upload-94",
  //   component: CheckDocsComparacion,
  //   layout: "/admin",
  // }
];

export default dashboardRoutes;
